<div
  class="d-flex align-items-center w100 div-alert-message"
  [ngClass]="background"
>
  <img *ngIf="icon" [src]="'./assets/icons/' + icon" alt="" />
  <span>{{ messageText }}</span>
</div>
